export type BillingExtra = {
    ctime: number;
    reg_notified: boolean;
    first_pay_dmr: Date;
    first_pay_order: Date;
};

export type BillingInfo = {
    postpaid: boolean;
    bind: boolean;
    bonus: number;
    legal_form: LegalForm;
    currency: string;
    domain: string;
    autopay: boolean;
    pid: string;
    balance: number;
    extra: BillingExtra;
};

export type BillingPayResponse = {
    url: string;
};

export type BillingMoreInfo = {
    domain?: string;
    balance?: string;
    bonus?: string;
    verified?: boolean;
    extra?: {
        legal_house: string;
        email: null;
        physical_post: null;
        bank_account: null;
        bank_name: null;
        legal_region: string;
        legal_city: string;
        representative_name: null;
        representative_position: null;
        correspondent_account: null;
        phone: string;
        physical_address: null;
        representative_signature: null;
        kpp: string;
        ogrn: string;
        bik: null;
        inn: string;
        legal_post: string;
        legal_street: string;
        legal_name: string;
    };
    legal_form?: LegalForm;
};

export type BillingSaveLegalData = {
    id: number;
    inn: string;
    kpp?: string;
    legal_city?: string;
    legal_house?: string;
    legal_name?: string;
    legal_post?: string;
    legal_region?: string;
    legal_street?: string;
    ogrn: string;
    phone: string;
};

export type BillingSaveIndividualData = {
    id: number;
    inn: string;
    legal_name?: string;
    physical_address?: string;
    ogrn: string;
    phone: string;
};

type Addres = {
    topoFullName: string;
    topoValue: string;
    topoShortName: string;
};
export type BillingSearchInnResultApiEntity = {
    UL?: {
        legalName: {
            short: string;
            full: string;
        };
        legalAddress?: {
            parsedAddressRF?: {
                house?: Addres;
                zipCode: string;
                regionName?: Addres;
                city?: Addres;
                settlement?: Addres;
                street?: Addres;
                kladrCode: string;
                bulkRaw: string;
                bulk?: Addres;
                regionCode: string;
                houseRaw: string;
            };
        };
        kpp: string;
    };
    IP?: {
        fio: string;
    };
    inn: string;
    ogrn: string;
};
export type BillingSearchInnResult = {
    legalForm: LegalForm;
    legalName: string;
    inn: string;
    ogrn: string;
    kpp?: string;
    zipCode?: string;
    regionCode?: string;
    legalCity?: string;
    legalStreet?: string;
    legalHouse?: string;
};

export enum LegalForm {
    unknown = 'unknown',
    individual = 'individual',
    legal = 'legal',
}
